import React, { useState, useEffect, useRef, useCallback } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function ImageSliderTaille() {

  const sliderRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [scale, setScale] = useState(1);

  const images = Array.from({ length: 6 }, (_, i) => i + 1);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
autoplay: true,
          autoplaySpeed: 2500,    arrows: true,
    draggable: true,
    swipe: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 2, arrows: false, autoplay: true } },
      { breakpoint: 767, settings: { slidesToShow: 1, arrows: false, autoplay: true } }
    ]
  };

  const open = (index) => {
    setSelectedIndex(index);
    setScale(1);
  };

  const next = useCallback((e) => {
    if (e) e.stopPropagation();
    setSelectedIndex((prev) => (prev + 1) % images.length);
    setScale(1);
  }, [images.length]);

  const prev = useCallback((e) => {
    if (e) e.stopPropagation();
    setSelectedIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
    setScale(1);
  }, [images.length]);

  const close = useCallback(() => {
    if (sliderRef.current && selectedIndex !== null) {
      sliderRef.current.slickGoTo(selectedIndex, true);
    }
    setSelectedIndex(null);
    setScale(1);
  }, [selectedIndex]);

  useEffect(() => {
    const handleKey = (e) => {
      if (selectedIndex === null) return;
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "Escape") close();
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [selectedIndex, next, prev, close]);

  useEffect(() => {
    document.body.style.overflow =
      selectedIndex !== null ? "hidden" : "auto";
  }, [selectedIndex]);

  const handleWheel = (e) => {
    e.stopPropagation();
    setScale((prev) =>
      Math.min(Math.max(prev - e.deltaY * 0.001, 1), 3)
    );
  };

  let startX = 0;

  const handleTouchStart = (e) => {
    startX = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const endX = e.changedTouches[0].clientX;
    if (startX - endX > 50) next(e);
    if (endX - startX > 50) prev(e);
  };

  const tailles = [
  { label: "Taille S", prix: "de 30 à 45€" },
  { label: "Taille M", prix: " de 50 à 65€" },
  { label: "Taille L", prix: "de 70 à 95€" },
  { label: "Taille XL", prix: "de 100 à 165€" },
  { label: "Taille XXL", prix: "de 170 à 300€" },
  { label: "Taille XXXL", prix: "de 300 à 500€" }
];
  return (
    <>
   <Slider ref={sliderRef} {...settings} className="slider-fleuristerie">

  {images.map((num, index) => (
    <div key={num}>

      <div style={{ padding: "0 10px", boxSizing: "border-box" }}>

        <div
          style={{
            height: "300px",
            borderRadius: "12px",
            overflow: "hidden",
            transition: "transform 0.3s ease"
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.05)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "scale(1)")
          }
        >

          <img
            src={`/img/version1/bouquets/taillesbouquets/${num}.jpg`}
            loading="lazy"
            alt="Bouquet blanc fleuriste Chennevières sur marne"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
              cursor: "pointer"
            }}
            onClick={() => open(index)}
          />

        </div>

        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <h3 style={{ margin: "5px 0", color: "#E01174" }}>
            {tailles[index]?.label}
          </h3>
          <p style={{ margin: 0, color: "#333" }}>
            {tailles[index]?.prix}
          </p>
        </div>

      </div>
    </div>
  ))}

</Slider>

      {selectedIndex !== null && (
        <div style={styles.overlay} onClick={close}>
          <button style={styles.close}>✕</button>
          <button style={styles.prev} onClick={prev}>‹</button>

          <img
            src={`/img/version1/bouquets/taillesbouquets/${images[selectedIndex]}.jpg`}
                  alt={`Bouquet blanc fleuriste Chennevières sur marne`}
            style={{
              ...styles.fullImage,
              transform: `scale(${scale})`,
            }}
            onClick={(e) => e.stopPropagation()}
            onWheel={handleWheel}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          />

          <button style={styles.next} onClick={next}>›</button>
        </div>
      )}
    </>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.95)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },

  fullImage: {
    maxWidth: "90%",
    maxHeight: "90%",
    objectFit: "contain",
  },

  close: {
    position: "absolute",
    top: "20px",
    right: "30px",
    fontSize: "30px",
    color: "white",
    background: "none",
    border: "none",
    cursor: "pointer",
  },

  prev: {
    position: "absolute",
    left: "20px",
    fontSize: "40px",
    color: "white",
    background: "none",
    border: "none",
  },

  next: {
    position: "absolute",
    right: "20px",
    fontSize: "40px",
    color: "white",
    background: "none",
    border: "none",
  },
};

export default ImageSliderTaille;